import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { HookInterfaceListQuery } from '@rossum/api-client/hookInterfaces';
import { useApiClient } from '../../../lib/apiClient';
import { hookInterfacesEnabledSelector } from '../../../redux/modules/organizationGroup/selectors';

export const HOOK_INTERFACES_QUERY_KEY = 'hook_interfaces';

export const useHookInterfaces = (payload: HookInterfaceListQuery) => {
  const hookInterfacesEnabled = useSelector(hookInterfacesEnabledSelector);

  const api = useApiClient();

  const hookInterfaces = useQuery({
    queryKey: [HOOK_INTERFACES_QUERY_KEY, payload],
    queryFn: () => api.request(endpoints.hookInterfaces.list(payload)),
    enabled: hookInterfacesEnabled,
  });

  return hookInterfaces;
};
